// extracted by mini-css-extract-plugin
module.exports = {"answers":"answer_answers__2c_kj","answer":"answer_answer__21706","correct":"answer_correct__1QgHq","wrong":"answer_wrong__27p4E"};